<template>
  <transition name="fade-down">
    <div v-if="errors?.length" class="input__errors">
      <span v-for="(error, i) in errors" :key="i" class="input__error">
        {{ error }}
      </span>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  errors: Array,
})
</script>
